<template>
  <div class="already-tips">
    <img src="//res13.xesimg.com/x5mall/img/login-tips_new.png" alt="" />
    <span>已帮您选择难度</span>
    <em></em>
    <i class="iconfont1 icon-guanbi" @click.stop="closeSelf"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    closeSelf() {
      this.$emit('closeTip')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(already-tips) {
  position: absolute;
  top: -61px;
  left: 50%;
  transform: translate(-50%, 0);
  display: inline-block;
  background: #f45a61;
  height: 51px;
  width: 180px;
  line-height: 51px;
  padding: 0 18px;
  border-radius: 70px;
  box-shadow: 0px 0px 8px rgba(191, 12, 12, 0.34);
}
.already-tips img {
  width: 38px;
  height: auto;
  margin-right: 10px;
  vertical-align: middle;
}
.already-tips span {
  color: #fff;
  padding: 0;
  margin: 0;
  margin-left: -4px;
  font-size: 15px;
}
.already-tips i {
  color: #fff;
  cursor: pointer;
  margin-top: -3px;
  margin-left: 10px;
  font-size: 12px;
  display: inline-block;
}
.already-tips em {
  display: inline-block;
  border: 10px solid transparent;
  border-top: 11px solid #f45a61;
  width: 0;
  height: 0;
  position: absolute;
  right: 100px;
  bottom: -17px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseCenter/components/AlreadyDegree.vue